export * from './accountPaycard.component';